// «Обране» меню: коды пунктов у учётной записи на сервере (F-013, решение 066).
//
// ⚠ Хранится только список кодов (правило 11); подписи, группы и право видеть
// пункт берутся из меню при показе. Звёздочка меняет список сразу, запись идёт
// в очередь — быстрые нажатия не обгоняют друг друга; сбой записи не молчит:
// список возвращается к тому, что у сервера, и человеку говорят словами.

import { useCallback, useEffect, useRef, useState } from "react";

import { askFavorites, putFavorites } from "./api";

export interface Favorites {
  /** Коды в порядке добавления. */
  readonly codes: readonly string[];
  /** Последнее сохранение не удалось. */
  readonly failed: boolean;
  readonly toggle: (code: string) => void;
}

/** `enabled` — меню уже пришло: спрашивать «Обране» раньше незачем. */
export function useFavorites(enabled: boolean): Favorites {
  const [codes, setCodes] = useState<readonly string[]>([]);
  const [failed, setFailed] = useState(false);
  const latest = useRef<readonly string[]>([]);
  const queue = useRef<Promise<void>>(Promise.resolve());

  const put = useCallback((next: readonly string[]) => {
    latest.current = next;
    setCodes(next);
  }, []);

  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    void askFavorites().then((got) => {
      if (alive && got !== null) put(got);
    });
    return () => {
      alive = false;
    };
  }, [enabled, put]);

  const toggle = useCallback(
    (code: string) => {
      const was = latest.current;
      const next = was.includes(code) ? was.filter((one) => one !== code) : [...was, code];
      put(next);
      setFailed(false);
      queue.current = queue.current.then(async () => {
        if ((await putFavorites(next)) !== null) return;
        setFailed(true);
        const server = await askFavorites();
        if (server !== null) put(server);
      });
    },
    [put],
  );

  return { codes, failed, toggle };
}
